import { useState } from 'react'
import { Button } from '@chakra-ui/react'
import { LuShieldCheck } from 'react-icons/lu'
import { showSuccess } from '@/lib/alert'
import { usePromoteAgendaMember } from '@/hooks/agendas/usePromoteAgendaMember'
import ConfirmActionDialog from '@/components/ConfirmActionDialog'
import type { AgendaMember } from '@/services/agendas'

type Props = {
  agendaId: string
  member: AgendaMember
}

const PromoteMemberButton = ({ agendaId, member }: Props) => {
  const [open, setOpen] = useState(false)
  const { mutate: promote, isPending } = usePromoteAgendaMember(agendaId)

  const handleConfirm = () => {
    promote(member.user.id, {
      onSuccess: () => {
        showSuccess('Membro promovido a admin com sucesso!')
        setOpen(false)
      },
    })
  }

  return (
    <>
      <Button colorPalette="blue" variant="outline" size="xs" onClick={() => setOpen(true)}>
        <LuShieldCheck />
        Tornar Admin
      </Button>

      {open && (
        <ConfirmActionDialog
          open={open}
          onOpenChange={setOpen}
          title="Tornar admin"
          body={<>Tem certeza que deseja tornar <strong>{member.user.name}</strong> um admin desta agenda?</>}
          onConfirm={handleConfirm}
          confirmColorPalette="blue"
          isPending={isPending}
        />
      )}
    </>
  )
}

export default PromoteMemberButton
